import React from 'react';
import styles from './Features.module.css';

const Features = () => {
  const features = [
    {
      title: 'AI-Powered Weekly Architecture',
      desc: 'Our planning engine interprets your profile, goals, schedule, and equipment to generate a realistic 7-day structure built for adherence, not intensity theatre.',
      highlight: 'Reliable Logic',
    },
    {
      title: 'Rich Exercise Guidance',
      desc: 'Every movement includes clear instructions, intent, duration, and practical execution guidance so the plan feels usable the moment it is generated.',
      highlight: 'No Guesswork',
    },
    {
      title: 'Daily Adherence Scoring',
      desc: 'Check in daily, track steps and sessions, and build momentum through visible consistency rather than vague motivation.',
      highlight: 'Stay Accountable',
    },
  ];

  return (
    <section id="features" className={styles.section}>
      <div className={styles.container}>
        <div className={styles.textBlock}>
          <span className={styles.kicker}>Expertly Crafted Features</span>

          <h2 className={styles.heading}>
            The science of <span>sustainable fat loss.</span>
          </h2>

          <p className={styles.subheading}>
            LeanWeek-AI combines practical weekly planning, structured workout
            guidance, and a privacy-first product model to help users stay
            consistent without unnecessary complexity.
          </p>
        </div>

        <div className={styles.featureList}>
          {features.map((f, i) => (
            <article key={i} className={styles.featureCard}>
              <div className={styles.cardTop}>
                <div className={styles.badge}>{f.highlight}</div>
                <span className={styles.index}>0{i + 1}</span>
              </div>

              <h3 className={styles.cardTitle}>{f.title}</h3>
              <p className={styles.cardDesc}>{f.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;